import { LoginResponseDto } from '../models/DTO/LoginResponseDto.model';
import { Inject, inject, Injectable } from '@angular/core';
import { DefaultAuthService, DefaultUtilService, LOGIN_CONFIG,
  LoginConfig
 } from 'login-angular13';
import { LoginService } from './micros/login.service';
import { LoginDto } from '../models/DTO/LoginDto.model';
import { LoginModel } from '../models/login.model';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BovedaAuthService extends DefaultAuthService {
  private readonly _hostAuthService = inject(LoginService);
  private readonly _router = inject(Router);

  constructor(
    http: HttpClient,
    @Inject(LOGIN_CONFIG) config: LoginConfig) {
    super(http, config);
  }

  override loginUser(accessToken: string, refreshToken: string): void {
    super.loginUser(accessToken, refreshToken);
    this._hostAuthService.loginUser(accessToken, refreshToken);
    this._hostAuthService.obtenerInformacionUsuario().then(async (result) =>{
      if(result.exito){
        await this._router.navigateByUrl('/inicio');
      } else {
        localStorage.clear();
        await this._router.navigateByUrl('/login');
      }
    })
    .catch(() => {
      localStorage.clear();
      void this._router.navigateByUrl('/login');
    });
  }

  override setUserInSession(value: boolean): void {
    super.setUserInSession(value);
  }
}

@Injectable({
  providedIn: 'root',
})
export class BovedaUtilService extends DefaultUtilService {
  private readonly _hostUtilService = inject(LoginService);

  constructor(@Inject(LOGIN_CONFIG) config: LoginConfig) {
    super(config);
  }
}
